export default {
  isString: function (str) {
    if (typeof str === 'string' || str instanceof String) return true;
    return false;
  },
};
